// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideZoomOut as RawLucideZoomOut } from "lucide-react";
export const LucideZoomOut = /* @__PURE__ */ createIcon(RawLucideZoomOut, "LucideZoomOut", 2);
